import { motion, AnimatePresence } from 'framer-motion';
import { useEffect, useState } from 'react';

export default function Preloader() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handleLoad = () => {
      // Small delay to ensure smooth transition
      setTimeout(() => setLoading(false), 800);
    };

    if (document.readyState === 'complete') {
      handleLoad();
    } else {
      window.addEventListener('load', handleLoad);
      return () => window.removeEventListener('load', handleLoad);
    }
  }, []);

  return (
    <AnimatePresence>
      {loading && (
        <motion.div
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.8, ease: "easeInOut" }}
          className="fixed inset-0 z-[9999] bg-white flex flex-col items-center justify-center overflow-hidden"
        >
          {/* Logo Animation */}
          <motion.div
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ 
              duration: 1,
              ease: "easeOut"
            }}
            className="relative mb-8"
          >
            <img 
              src="https://blogger.googleusercontent.com/img/a/AVvXsEgk90zcNlep_PggBeutpAelZBCPIxHzO2NSOzQe9Mps-_8DjjQ2Uka89cam_ZKDmP_tv9UPcdrEu3KrcJtp5VFczXJhNruom741Knt2dtbFaAq1_-EAd8oTZqUgKSBa3ORoU3mvBT6ECZO7OiZbRcQmEcoS05PBRTMH1EZ7_eh7vkdR3HT1rmRnQlqOmiqx" 
              alt="الحلول الرقمية" 
              width={128}
              height={128}
              className="h-24 md:h-32 w-auto brightness-110"
              loading="eager"
              fetchPriority="high"
              decoding="async"
              referrerPolicy="strict-origin-when-cross-origin"
              onContextMenu={(e) => e.preventDefault()}
              draggable={false}
            />
            
            {/* Pulsing Ring */}
            <motion.div 
              className="absolute -inset-4 border-2 border-brand-accent/30 rounded-full"
              animate={{
                scale: [1, 1.2, 1],
                opacity: [0.3, 0.6, 0.3],
              }}
              transition={{
                duration: 2,
                repeat: Infinity,
                ease: "easeInOut"
              }}
            />
          </motion.div>

          {/* Loading Bar */}
          <div className="w-48 h-1 bg-white/10 rounded-full overflow-hidden relative">
            <motion.div 
              className="absolute top-0 left-0 h-full bg-brand-accent shadow-[0_0_15px_rgba(184,146,84,0.5)]"
              initial={{ width: "0%" }}
              animate={{ width: "100%" }}
              transition={{ 
                duration: 1.5,
                ease: "easeInOut"
              }}
            />
          </div>
          
          <motion.p
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5 }}
            className="mt-4 text-brand-dark/60 font-medium tracking-widest text-xs uppercase"
          >
            جاري التحميل...
          </motion.p>

          {/* Background Decorative Element */}
          <motion.div 
            className="absolute -bottom-24 -right-24 w-96 h-96 bg-brand-accent/5 blur-[80px] rounded-full"
            animate={{
              scale: [1, 1.2, 1],
              opacity: [0.1, 0.2, 0.1],
            }}
            transition={{
              duration: 4,
              repeat: Infinity,
              ease: "easeInOut"
            }}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
